import { render, staticRenderFns } from "./admin-olimpiada-2024-show.vue?vue&type=template&id=c89f3d1e&scoped=true"
import script from "./admin-olimpiada-2024-show.vue?vue&type=script&lang=js"
export * from "./admin-olimpiada-2024-show.vue?vue&type=script&lang=js"
import style0 from "./admin-olimpiada-2024-show.vue?vue&type=style&index=0&id=c89f3d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89f3d1e",
  null
  
)

export default component.exports